import React from 'react';
import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';


import m492015 from '../media/ift/InternetInRecargas/FormatoSimplificado_492015.pdf';
import m492016 from '../media/ift/InternetInRecargas/FormatoSimplificado_492016.pdf';
import m492018 from '../media/ift/InternetInRecargas/FormatoSimplificado_492018.pdf';
import m492019 from '../media/ift/InternetInRecargas/FormatoSimplificado_492019.pdf';
import m619933 from '../media/ift/InternetInRecargas/FormatoSimplificado_619933.pdf';
import m619936 from '../media/ift/InternetInRecargas/FormatoSimplificado_619936.pdf';





const Rates = props =>
{
    return (
        <div id='rates' className='container p-4'>
            <TocPage history={props.history} links={getLegalLinks()}>
                <h4 className='mb-4'>REGISTRO DE TARIFAS ANTE IFT</h4>

                  <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO RECARGAS PREPAGO</th>
                        </tr>
                        <tr>
                            <th>ON INALÁMBRICO</th>
                            <th>FOLIO DE TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>ON Inalámbrico 5 / 20 GB / semanal</td>
                            <td><a href={m492015} target='_blank' rel='noopener noreferrer'>492015</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico 5 / 30 GB / semanal</td>
                            <td><a href={m492016} target='_blank' rel='noopener noreferrer'>492016</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico 5 / 80 GB / mensual</td>
                            <td><a href={m619933} target='_blank' rel='noopener noreferrer'>619933</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 20 GB / semanal</td>
                            <td><a href={m492015} target='_blank' rel='noopener noreferrer'>492015</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 30 GB / semanal</td>
                            <td><a href={m492016} target='_blank' rel='noopener noreferrer'>492016</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 80 GB / mensual</td>
                            <td><a href={m619933} target='_blank' rel='noopener noreferrer'>619933</a></td>
                        </tr>
                        <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO RECARGAS PREPAGO FRANJA FRONTERIZA</th>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico 5 / 20 GB / semanal</td>
                            <td><a href={m492018} target='_blank' rel='noopener noreferrer'>492018</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico 5 / 30 GB / semanal</td>
                            <td><a href={m492019} target='_blank' rel='noopener noreferrer'>492019</a></td>
                        </tr>
                        <tr>
                            <td>ON Inalámbrico 5 / 80 GB / mensual</td>
                            <td><a href={m619936} target='_blank' rel='noopener noreferrer'>619936</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 20 GB / semanal Franja Fronteriza</td>
                            <td><a href={m492018} target='_blank' rel='noopener noreferrer'>492018</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 30 GB / semanal Franja Fronteriza</td>
                            <td><a href={m492019} target='_blank' rel='noopener noreferrer'>492019</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 80 GB / Mensual Franja Fronteriza</td>
                            <td><a href={m619936} target='_blank' rel='noopener noreferrer'>619936</a></td>
                        </tr>
                        
                      
                    </tbody>
                </table>


                <p>Las tarifas ante señaladas pueden consultarse en el Registro Público de Concesiones, publicado en la página electrónica del Instituto Federal de Telecomunicaciones</p>
            </TocPage>
        </div>
    );
}

export default Rates;



// WEBPACK FOOTER //
// ./src/components/Rates_in_pre.js